import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DASHBOARD_FINISH_TASKS } from './actionTypes';
import { getDashboardFinishTasksSuccess, getDashboardFinishTasksError } from './actions';
import { taskStatusBack } from '../../../constants/task_fields';

// Include call API
import { getTasksAPI } from '../../../api/tasks';

const tasksAPI = getTasksAPI();

const FINISH_STATUS = `${taskStatusBack.FINALIZADA}`;

function* getDashboardFinishTasks({ payload: { user, size, page } }) {
  try {
    const response = yield call(tasksAPI.getTasks, user.token, size, page, FINISH_STATUS);
    yield put(getDashboardFinishTasksSuccess(response.paginator, response.message));
  } catch (error) {
    yield put(getDashboardFinishTasksError(error));
  }
}

export function* watchGetDashboardFinishTasks() {
  yield takeEvery(GET_DASHBOARD_FINISH_TASKS, getDashboardFinishTasks);
}

function* getDashboardFinishTasksSaga() {
  yield all([fork(watchGetDashboardFinishTasks)]);
}

export default getDashboardFinishTasksSaga;
